// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

import wixWindow from 'wix-window';
import wixLocation from 'wix-location';


export function videoPlayer1_play(event) {
	wixWindow.trackEvent("CustomEvent", {
	"event": "Video Play",
	"eventCategory": "Content",
	"eventAction": "Watch",
    "eventLabel": "VideoWatch: Main"
} );
}

export function TextAdventureTripPassTitle_viewportEnter(event) {
	wixWindow.trackEvent("CustomEvent", {
	"event": "Content Visible",
	"eventCategory": "ContentView",
	"eventAction": "OnScreen",
    "eventLabel": "Viewed: Adventure Trip Passes"
} );
}

export function ButtonMoreReviews_viewportEnter(event) {
	wixWindow.trackEvent("CustomEvent", {
	"event": "Content Visible",
	"eventCategory": "ContentView",
	"eventAction": "OnScreen",
    "eventLabel": "Viewed: Bottom Page More Reviews Button "
} ); 
}

export function MoreHighlightsButton_click(event) {

	wixWindow.trackEvent("CustomEvent", {
	"event": "ButtonClick",
	"eventCategory": "Site Content",
	"eventAction": "Click",
    "eventLabel": "Click Button: To Highlight Page"
} );  
	wixLocation.to("/canada-tour-experiences");
}

export function MoreRoadTrips_click(event) {
	wixWindow.trackEvent("CustomEvent", {
	"event": "ButtonClick",
	"eventCategory": "Site Content",
	"eventAction": "Click",
    "eventLabel": "Click Button: To All Adventures Page"
} );  
	wixLocation.to("/adventure");
}

export function MoreAboutUs_click(event) {
	wixWindow.trackEvent("CustomEvent", {
	"event": "ButtonClick",
	"eventCategory": "Site Content",
	"eventAction": "Click",
    "eventLabel": "Click Button: To About Us Page"
} ); 
	wixLocation.to("/about-us");

}

export function ButtonMoreReviews_click(event) {
	wixWindow.trackEvent("CustomEvent", {
	"event": "ButtonClick",
	"eventCategory": "Site Content",
	"eventAction": "Click",
    "eventLabel": "Click Button: To Reviews Page"
} );  
	wixLocation.to("/customer-reviews-and-testimonials");

}
